/*******************************************************************************
*  Configurações e Plugins
*******************************************************************************
*/

/*******************************************************************************
*  Index
*******************************************************************************
*/
$(document).ready(function(){
     //Dont Drag Images
     $('img').on('dragstart', function(event) { event.preventDefault(); });

    //Fill Images into block, support IE 6
    $(".imgLiquidFillDefault2").imgLiquid({
      fill: true,
      horizontalAlign: "center",
      verticalAlign: "center"
    });

    if ($(window).width() < 960) {
      $('.banner').css("animation", "none");
    }

    //Scroll intent da página
    $(function () {
      $.scrollUp({
        scrollText: '<i class="icon-angle-up" alt="Voltar ao Topo"></i>',
        animationSpeed: 400,
        scrollSpeed: 600,
        scrollTitle: "Voltar ao Topo",
        easingType: 'easeInOutQuad'
      });
    });

    //Scroll show header script
    $("#header.interno").headroom({
    });
    //Controla a visão de altura do header para o headroom e fixed
    $('body.interno').css('padding-top', $('#header').height() + 'px', 'important');
    $(window).resize(function() {
      $('body.interno').css('padding-top', $('#header').height() + 'px', 'important');
    });

    //Rate yo interno detalhes
    $(".my-rating").each(function(e) {
      var rate = $(this).attr("data-avaliacao");
      $(this).rateYo({
        rating: rate,
        starWidth: "20px",
        spacing: "4px",
        readOnly: true,
        ratedFill: "#ffc240",
        normalFill: "#dddddd",
        "starSvg": "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>"+
        "<path xmlns='http://www.w3.org/2000/svg' d='M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z'/>"+
        "</svg>"
      });
    });
    $(".my-rating-low").each(function(e) {
      var rate = $(this).attr("data-avaliacao");
      $(this).rateYo({
        rating: rate,
        starWidth: "15px",
        spacing: "2px",
        readOnly: true,
        ratedFill: "#ffc240",
        normalFill: "#dddddd",
        "starSvg": "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>"+
        "<path xmlns='http://www.w3.org/2000/svg' d='M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z'/>"+
        "</svg>"
      });
    });

    // Only runs when look at the image
   //  echo.init({
   //    offset: 0,
   //    throttle: 250,
   //    unload: false,
   //    debounce: false,
   //    callback: function (element, op) {
   //     $(element).parent().addClass('imgLiquidFill');
   //     //Fill Images into block, support IE 6
   //     $(".imgLiquidFill").imgLiquid({
   //      fill: true,
   //      horizontalAlign: "center",
   //      verticalAlign: "center"
   //    });
   //   }
   // });

   //Tradução magnific popup
   $.extend(true, $.magnificPopup.defaults, {
      tClose: 'Fechar (Esc)', // Alt text on close button
      tLoading: 'Carregando...', // Text that is displayed during loading. Can contain %curr% and %total% keys
      gallery: {
        tPrev: 'Anterior', // Alt text on left arrow
        tNext: 'Próximo', // Alt text on right arrow
        tCounter: '%curr% de %total%' // Markup for "1 of 7" counter
      },
      image: {
        tError: '<a href="%url%">A Imagem</a> não pode ser carregada.' // Error message when image could not be loaded
      },
      ajax: {
        tError: '<a href="%url%">O Conteúdo</a> não pode ser carregado.' // Error message when ajax request failed
      }
    });

   //Selectize Modal
   $('.menu-cidades #regiao').selectize({
    preload: true,
    render: {
      item: function(item, escape) {
        html = '<div class="item-select">' +
        '<span class="image">' +
        '<img src="' + item.img + '">' +
        '</span>' +
        '<div class="atributos">' +
        '<div class="titulo">' + item.nome+ '</div>'  +
        '</div>';
        html = html + '</div>';
        return html;
      },
      option: function(item, escape) {
        html = '<div class="item-select">' +
        '<span class="image">' +
        '<img src="' + item.img + '">' +
        '</span>' +
        '<div class="atributos">' +
        '<div class="titulo">' + item.nome + '</div>'  +
        '</div>';
        html = html + '</div>';
        return html;
      }
    },
  });

  // Parallax
  $('.bgParallax').each(function(){
    var $obj = $(this);

    $(window).scroll(function() {
      var yPos = -($(window).scrollTop() / $obj.data('speed'));
      var bgpos = yPos + 'px';
      $obj.css('top', bgpos );
    });
  });
  //A link href smooth
  $('a[href*=#]:not([href=#])').click(function() {
    //if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          //I put the size of the fixed here
          scrollTop: (target.offset().top)-40
        }, 700, function(){
         $('#termo').focus();
       });
        return false;
      }
    //}
  });
  //Open and Close Responsive itens
  $('.open-close').click(function() {
    $(this).find('.item-to-open').toggle("slide");
  });

  //Chamada das Validações
  validaBusca()
  validaBuscaModal()
  validaNews();
  validaContatoEmpresa();
  validaCadastro();
  validaContato();
  validaAvaliacao();
  BuscaSubs();
  BuscaCidades();

  //Rating
  $(".my-rating-send").each(function(e) {
    $(this).rateYo({
      rating: 0,
      starWidth: "29px",
      fullStar: true,
      ratedFill: "#ffc240",
      normalFill: "#dddddd",
      "starSvg": "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>"+
      "<path xmlns='http://www.w3.org/2000/svg' d='M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z'/>"+
      "</svg>"
    });
  });

  //Redirect das regiões
  $('#regiao').change(function(){
    window.open($(this).val(), '_blank');
  });


/*******************************************************************************
*  OFF CANVAS SIDEBAR
*******************************************************************************/
  //Inicializando sidebar right
  var controller = new slidebars();
  controller.init();
  // Toggle Slidebars
  $('.toggle-id-1').on('click', function ( event ) {
    // Stop default action and bubbling
    event.stopPropagation();
    event.preventDefault();
    // Toggle the Slidebar with id 'id-1'
    controller.toggle('id-1');

    //Chamando a função para carregar categoria
    carregaCategorias();
  });
  // Add close class to canvas container when Slidebar is opened
  $( controller.events ).on( 'opening', function ( event ) {
    $( '[canvas]' ).addClass( 'js-close-any' );
  });
  // Add close class to canvas container when Slidebar is opened
  $( controller.events ).on( 'closing', function ( event ) {
    $( '[canvas]' ).removeClass( 'js-close-any' );
  });
  $( document ).on( 'click', '.js-close-any', function ( event ) {
    if ( controller.getActiveSlidebar() ) {
      event.preventDefault();
      event.stopPropagation();
      controller.close();
    }
  });

  //Função que inicializa accordion do sidebar
  function initSlick(){
    $('.off-canvas-item .categorias-item').slicknav({
      label: 'Categorias',
      duration: 600,
      duplicate: false,
      prependTo:'.container-categorias-sidebar',
      allowParentLinks: true,
      closedSymbol: '<i class="icon-plus" aria-hidden="true"></i>',
      openedSymbol: '<i class="icon-minus" aria-hidden="true"></i>',
      init: function(){
        $('.off-canvas-item .categorias .slicknav_btn').removeClass('slicknav_collapsed');
        $('.off-canvas-item .categorias .slicknav_btn').addClass('slicknav_open');
        $('.off-canvas-item .categorias .slicknav_nav').removeClass('slicknav_hidden');
        $('.off-canvas-item .categorias .slicknav_nav').css('display', '');

        $(".off-canvas-item .loader-categoria").fadeOut(800);
        $('.off-canvas-item .categorias').fadeIn({queue: false, duration: 800});
        $('.off-canvas-item .categorias').animate({ top: "0" }, 800);
      },
    });

    //Fecha o off-canvas no clique de categorias
    $('.off-canvas-item .slicknav_btn.slicknav_open').off('click');
    $('.off-canvas-item .slicknav_btn.slicknav_open').on('click', function(event){
      event.preventDefault();
      event.stopPropagation();
      if ( controller.getActiveSlidebar() ) {
        controller.close();
      }
    });
  }

  //Variável pra controlar o ajax
  var _CARREGA = true;

  //Carregando as categorias assincronamente
  function carregaCategorias(){
    if(_CARREGA){
      _CARREGA = false;
      $.ajax({
        type: "POST",
        url: "php-categorias-sidebar.php",
        success: function(resposta)
        {
          //alert(resposta);
          $(".off-canvas-item .categorias-item").html(resposta);
          initSlick();
        },
      });
    }
  }


  /*******************************************************************************
  *  Selectize Busca Principal
  *******************************************************************************/
  /*$('.selectize-principal').selectize({
    onEnterKeypress: function(el) {
        alert('teste');
        $('#frmBusca').submit();
    }
  });*/
  s = $('.selectize-principal').selectize({
    onEnter: function() {
      $("#frmBusca").submit();
      errosForm('frmBusca');
    }
  })[0].selectize;

  onKeyDown = s.onKeyDown.bind(s)
  s.onKeyDown = function(e) {
    var result = onKeyDown(e)
    if (e.keyCode == 13) {
      this.settings.onEnter()
    }
    return result
  }.bind(s);
});

//Setando valor do rating à um hidden
$(function () {
  $(".my-rating-send").rateYo().on("rateyo.set", function (e, data) {
    $("#frmAvaliacao #score").val(data.rating);
  });
});

/*******************************************************************************
*  Header
*******************************************************************************
*/
// $(function(){
//  $('#header #menu').slicknav({
//    duration: 800,
//    prependTo: "#header .menu-responsivo",
//    init: function() {
//      // $("#header .slicknav_menutxt").html("<i class='fa fa-bars'></i>");
//      $("#header .slicknav_icon").html("<span class='slicknav_icon-bar first'></span><span class='slicknav_icon-bar second'></span><span class='slicknav_icon-bar third'></span>")
//    }
//  });

//  var content = $('#header .slicknav_nav').html();
//  $('#header .slicknav_nav').html("");
//  $('#header .slicknav_nav').prepend("<div class='mininav'></div>");
//  $('#header .slicknav_nav .mininav').html(content);

//  $("<button type='button' class='overlay-close'>Close</button>").prependTo('#header .slicknav_nav');

//  $('#header .overlay-close').click(function(event) {
//    $('#header #menu').slicknav('close');
//  });
//  $('#header .slicknav_nav li a').click(function(event) {
//    $('#header #menu').slicknav('close');
//  });
// });

/*******************************************************************************
*  Home
********************************************************************************/
if(document.getElementById('home')){
  $(document).ready(function(){
  });
}
/*******************************************************************************
*  Bloco Slide Empresas
********************************************************************************/
$(document).ready(function(){
  $('.empresas-slide .items').on('lazyLoaded', function (e, slick, img, src) {
    // $(img).parent().addClass('imgLiquidFill');
    // $(img).parent().imgLiquid({
    //   fill: true,
    //   horizontalAlign: "center",
    //   verticalAlign: "center"
    // });
  });
  $('.empresas-slide .items').slick({
    adaptiveHeight: true,
    arrows: true,
    dots: false,
    infinite: true,
    slidesToShow: 4,
    swipeToSlide : true,
    autoplay: true,
    autoplaySpeed: 5000,
    touchThreshold: 70,
    prevArrow: '<div class="snick-btn left"><button type="button" class="slick-prev"><span><i class="icon-arrow-left"></i></span></button></div>',
    nextArrow: '<div class="snick-btn right"><button type="button" class="slick-next"><span><i class="icon-arrow-right"></i></span></button></div>',
    lazyLoad: 'ondemand',
    responsive: [
    {
      breakpoint: 980,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
    ]
  });
});

/*******************************************************************************
*  Bloco Categorias
********************************************************************************/
if(document.getElementById('categorias-bloco')){
  $(document).ready(function(){
   $('#categorias-bloco .bloco-interno .items').slick({
    adaptiveHeight: true,
    arrows: true,
    dots: false,
    infinite: true,
    slidesToShow: 7,
    swipeToSlide : true,
    autoplay: true,
    autoplaySpeed: 5000,
    touchThreshold: 70,
    prevArrow: '<div class="snick-btn left"><button type="button" class="slick-prev"><span>+</span></button></div>',
    nextArrow: '<div class="snick-btn right"><button type="button" class="slick-next"><span>+</span></button></div>',
    responsive: [
    {
      breakpoint: 980,
      settings: {
        slidesToShow: 5,
        autoplay: false,
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 4,
        autoplay: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        autoplay: false,
      }
    },
    {
      breakpoint: 380,
      settings: {
        slidesToShow: 2,
        autoplay: false,
      }
    }
    ]
  });
 });
}
/*******************************************************************************
*  Detalhes Empresa
********************************************************************************/
if(document.getElementById('detalhes-empresa')){
// SCRIPT Para permitir Ligar e Whatsapp fixed no responsivo
if ($(window).width() < 880) {
  $(".content-modal").append('<div class="detalhes-empresa"><div class="informacoes-gerais"><div class="bloco-item no-margin"><div id="fixed-bar"></div></div></div></div>');
  $(".detalhes-empresa .informacoes-gerais .bloco-item .bloco-acoes").appendTo("#fixed-bar");
  $(".interna.detalhes-empresa .informacoes-gerais .bloco-item .bloco-acoes").remove();
}

// CHANGE THE BELOW URL BETWEEN THE QUOTES

if ($('#canvas_streetviewpanorama').length){
// #################
// LOCATION SETTINGS
// #################
var latitude = parseFloat($('#canvas_streetviewpanorama').attr('data-lat'));
var longitude = parseFloat($('#canvas_streetviewpanorama').attr('data-long'));
var panoid = '';

// #############
// MORE SETTINGS
// #############
var zoom = 1;
// increment controls the speed of panning
// positive values pan to the right, negatives values pan to the left
var increment = 0.08;
var interval = 30;
var chevrons = false;
var closebutton = false;
var click2go = true;
var address = "";
var pan = "";
var doubleClickZoom = false;
var imageDateControl = true;
var scrollwheel = true;
var zoom_pos = "";
var zoom_size = "";
var zoom_start = 1.1;
var fullscreen = false;
var fullscreen_width;
var fullscreen_height;
var panorama;
var timer;
if(typeof(mode)=="undefined") {
  var mode = "undefined";
}
function init_gl() {
  if(mode == "webgl") {
    var c = document.getElementsByTagName("canvas_streetviewpanorama").item(0);
    if(c) {
      c.addEventListener("webglcontextrestored", function(){
        spinIt();
      }, false);
    }
  }
}
function init() {
  if(mode=="undefined") {
    mode = "html4";
    if(window.WebGLRenderingContext) {
      var testCanvas = document.createElement("canvas_streetviewpanorama");
      if(testCanvas) {
                //mode = "html5";
                document.getElementsByTagName("body").item(0).appendChild(testCanvas);
                var webgl_names = new Array();
                webgl_names.push("webgl");
                webgl_names.push("experimental-webgl");
                webgl_names.push("moz-webgl");
                webgl_names.push("webkit-3d");
                for(i=0;i<4;i++) {
                  try {
                    var context = testCanvas.getContext(webgl_names[i]);
                    if (context && typeof(context.getParameter) == "function") {
                      mode = "webgl";
                      break;
                    }
                  } catch(e) {
                  }
                }
                testCanvas.parentNode.removeChild(testCanvas);
              }
            }
          }
          var gps = new google.maps.LatLng(latitude,longitude);
          var address_control = false;
          var address_control_options = {position:google.maps.ControlPosition.TOP_LEFT};
          if(address != "") {
            address_control = true;
            address_control_options = {position:address};
          }
          var pan_control = false;
          var pan_control_options = {position:google.maps.ControlPosition.TOP_LEFT};
          if(pan != "") {
            pan_control = true;
            pan_control_options = {position:pan};
          }
          var zoom_control = false;
          var zoom_control_options = {position:google.maps.ControlPosition.TOP_LEFT,style:google.maps.ZoomControlStyle.DEFAULT};
          if(zoom_pos != "") {
            zoom_control = true;
            zoom_control_options = {position:zoom_pos, style:zoom_size};
          }
          var disableDoubleClickZoom = true;
          if(doubleClickZoom) {
            disableDoubleClickZoom = false;
          }
          var panoramaOptions = {
            pano: panoid,
            pov: {
              heading: 0,
              pitch:0,
              zoom:zoom
            },
            clickToGo: click2go,
            scrollwheel: scrollwheel,
            zoomControl: zoom_control,
            zoomControlOptions: zoom_control_options,
            panControl:pan_control,
            panControlOptions:pan_control_options,
            visible:true,
            mode:mode,
            addressControl:address_control,
            addressControlOptions:address_control_options,
              //linksControl:chevrons,
              disableDoubleClickZoom:disableDoubleClickZoom,
              imageDateControl:imageDateControl,
              scrollwheel:scrollwheel,
              enableCloseButton:closebutton,
              position: gps
            };
            var canvas = document.getElementById("canvas_streetviewpanorama");
            panorama = new google.maps.StreetViewPanorama(canvas, panoramaOptions);
            google.maps.event.addListener(panorama, 'closeclick', function() {
              show_map();
            });
            panorama.setPano(panoid);
            google.maps.event.addListener(panorama, 'pano_changed', function() {
              panoid = panorama.getPano();
            });
            if(canvas.onmouseover == null) {
              start_spin();
              setTimeout("init_gl();",1000);
            }
            if ($('#canvas_streetviewpanorama.scrolloff').length < 0) {
              canvas.onmouseover = stop_spin;
            }
            $('#canvas_streetviewpanorama').on('click',function(){
              stop_spin();
            });
            canvas.onmouseout = start_spin;
          }

          function show_map() {
            var canvas = document.getElementById("canvas_streetviewpanorama");
            canvas.onmouseover = function(){};
            canvas.onmouseout = function(){};
            stop_spin();
            var gps = new google.maps.LatLng(latitude,longitude);
            var map_options = {
              center: gps,
              zoom: 16,
              mapTypeId: google.maps.MapTypeId.ROADMAP
            };

            var canvas = document.getElementById("canvas_streetviewpanorama");
            panorama = new google.maps.Map(canvas,map_options);
            var mopts = {
              map: panorama,
              position: gps,
              visible: true
            };
            var marker = new google.maps.Marker(mopts);
            google.maps.event.addListener(marker, 'click', function() {
              init();
            });
          }

          function spinIt() {
            try {
              var pov = panorama.getPov();
              pov.heading += increment;
              while(pov.heading > 360.0) {
                pov.heading -= 360.0;
              }
              while(pov.heading < 0.0) {
                pov.heading += 360.0;
              }

              panorama.setPov(pov);
            } catch(e) {}
          }

          function stop_spin() {
            clearTimeout(timer);
          }

          function start_spin() {
            clearTimeout(timer);
            timer = setInterval("spinIt()",interval);
          }

          function goto_fullscreen() {
            var canvas = document.getElementById("canvas_streetviewpanorama");
            if(typeof(document.webkitCancelFullScreen) != "undefined") {
              canvas.webkitRequestFullScreen();
              fullscreen_width = canvas.clientWidth;
              fullscreen_height = canvas.clientHeight;
              canvas.style.width="100%";
              canvas.style.height="100%";
              document.addEventListener("webkitfullscreenchange", function () {
                if(!document.webkitIsFullScreen) {
                  var c = document.getElementById("canvas_streetviewpanorama");
                  c.style.width = fullscreen_width + "px";
                  c.style.height = fullscreen_height + "px";
                }
              }, false);
            } else if(typeof(document.mozCancelFullScreen) != "undefined") {
              console.log("moz");
              canvas.mozRequestFullScreen();
              fullscreen_width = canvas.clientWidth;
              fullscreen_height = canvas.clientHeight;
              canvas.style.width="100%";
              canvas.style.height="100%";
              document.addEventListener("mozfullscreenchange", function () {
                if(document.mozFullScreenElement == null) {
                  var c = document.getElementById("canvas_streetviewpanorama");
                  c.style.width = fullscreen_width + "px";
                  c.style.height = fullscreen_height + "px";
                  google.maps.event.trigger(panorama, 'resize')
                }
              }, false);
            }
          }

          $(window).ready(function(){
            $.when(loadGoogleMaps( 3, "AIzaSyC9HKe9y3LxXaUQyRCtReg218_irnbfCQo", "pt-br") )
            .then(function() {
              init();
              clickToChange360();
            });
          });

          // Desabilita o mouse no bloco apenas no clique
          function clickToChange360(){
            var mapItem = $('#canvas_streetviewpanorama');
            var mapContainer = $('#canvas_streetviewpanorama');
            var closeItem = '<div class="close-item">Clique aqui para cancelar</div>';
            mapItem.addClass('scrolloff');
            // mapContainer.on("mouseup",function(){
            //     mapItem.addClass('scrolloff');
            // });
            mapContainer.on("mousedown",function(){
              mapItem.removeClass('scrolloff');
              mapItem.addClass('scrollon');
              $('.googlemaps').prepend(closeItem);
            });
            mapItem.mouseleave(function () {
              mapItem.addClass('scrolloff');
              mapItem.removeClass('scrollon');
              $('.googlemaps .close-item').remove();
            });
            $('.googlemaps .close-item').on('click', function(){
              mapItem.addClass('scrolloff');
              mapItem.removeClass('scrollon');
              $('.googlemaps .close-item').remove();
            });
          }
        }
/*******************************************************************************
*** MAPA de Localização (Não Funciona)
********************************************************************************/
var map;
var MY_MAPTYPE_ID = 'custom_style';
function initializeMapTwo() {
  var featureOpts = [
  {
    stylers: [
    ]
  },
  {
    elementType: 'labels',
    stylers: [
    { visibility: 'on' }
    ]
  },
  {
    featureType: 'water',
    stylers: [
    { color: '#adadad' }
    ]
  }
  ];
  var mapOptions = {
    scrollwheel: false,
    zoom: 15,
    center: new google.maps.LatLng(-20.81438,-49.372386),
    mapTypeControlOptions: {
      mapTypeIds: [google.maps.MapTypeId.ROADMAP, MY_MAPTYPE_ID]
    },
    mapTypeId: MY_MAPTYPE_ID
  };

  map = new google.maps.Map(document.getElementById('mapa-item'),mapOptions);

  google.maps.event.addDomListener(window, "resize", function() {
   var center = map.getCenter();
   google.maps.event.trigger(map, "resize");
   map.setCenter(center);
 });
  var marker = new google.maps.Marker({
    map: map,
    position: map.getCenter(),
    icon: 'images/mapa-marcador.png'
  });
  var infowindow;
  var mycontent = "<div class='address'><h4>Rua Santos Dumont, 79 - Vila Ercília<br>São José do Rio Preto - SP<br>Tel: (17) 3214-6400</h4></div>";

  google.maps.event.addListener(marker, "click", function() {
    if (infowindow){
      infowindow.close();
    }
    infowindow = new google.maps.InfoWindow({content: mycontent});
    infowindow.open(map, marker);
    // map.panTo(myLatlng);
  });
  var geocoder = new google.maps.Geocoder();
  var endereco = $('.localizacao-central').val();

  geocoder.geocode({address: endereco}, function(results, status) {
    if (status == google.maps.GeocoderStatus.OK) {
      map.setCenter(results[0].geometry.location);
      //procurarMarkers(map);
    }
  });
  var styledMapOptions = {
    name: 'Alternativo'
  };
  var customMapType = new google.maps.StyledMapType(featureOpts, styledMapOptions);
  map.mapTypes.set(MY_MAPTYPE_ID, customMapType);
}
$(window).load(function(){
  if($('#mapa-item').length){
    initializeMapTwo();
  }
});


/*******************************************************************************
*** MAPA de Localização - Novo Código
********************************************************************************/
function initMap2(){
  var item = $('#mapa-item-2');
  var infowindow;
  var mycontent = "<div class='address'><h4>"+item.attr('data-endereco')+"<br>"+"Telefone: "+item.attr('data-telefone')+" <br><a href='http://www.google.com/maps/place/"+item.attr('data-lat')+","+item.attr('data-long')+"' target='_blank'>Acessar no Google Maps</a></h4></div>";
  var nomeEmpresa = item.attr('data-nome-empresa');

  if(item.attr('data-lat') != '' && item.attr('data-long') != ''){

    var myLatlng2 = new google.maps.LatLng(item.attr('data-lat'),item.attr('data-long'));

    var myOptions2 = {
     scrollwheel: false,
     zoom: 15,
     center: myLatlng2,
     mapTypeId: google.maps.MapTypeId.ROADMAP,
   }

   mapItem2 = new google.maps.Map($('#mapa-item-2')[0], myOptions2);
   google.maps.event.addDomListener(window, "resize", function() {
     var center = mapItem2.getCenter();
     google.maps.event.trigger(mapItem2, "resize");
     mapItem2.setCenter(center);
   });

   var marker = new google.maps.Marker({
    position: myLatlng2,
    map: mapItem2,
    title: nomeEmpresa,
    icon: 'images/mapa-marcador.png'
  });

   google.maps.event.addListener(marker, "click", function() {
    if (infowindow){
      infowindow.close();
    }
    infowindow = new google.maps.InfoWindow({content: mycontent});
    infowindow.open(mapItem2, marker);
  });

 }else{

  var geocoder = new google.maps.Geocoder();
  var address = item.attr('data-geoAddress');

  geocoder.geocode( { 'address': address}, function(results, status) {

    if (status == google.maps.GeocoderStatus.OK) {
      var latitude = results[0].geometry.location.lat();
      var longitude = results[0].geometry.location.lng();
      myLatlng2 = new google.maps.LatLng(latitude,longitude);
      var mycontent = "<div class='address'><h4>"+item.attr('data-endereco')+"<br>"+"Telefone: "+item.attr('data-telefone')+" <br><a href='http://www.google.com/maps/place/"+latitude+","+longitude+"' target='_blank'>Acessar no Google Maps</a></h4></div>";

      var myOptions2 = {
       scrollwheel: false,
       zoom: 15,
       center: myLatlng2,
       mapTypeId: google.maps.MapTypeId.ROADMAP,
     }

     mapItem2 = new google.maps.Map($('#mapa-item-2')[0], myOptions2);
     google.maps.event.addDomListener(window, "resize", function() {
       var center = mapItem2.getCenter();
       google.maps.event.trigger(mapItem2, "resize");
       mapItem2.setCenter(center);
     });

     var marker = new google.maps.Marker({
      position: myLatlng2,
      map: mapItem2,
      title: nomeEmpresa,
      icon: 'images/mapa-marcador.png'
    });

     google.maps.event.addListener(marker, "click", function() {
      if (infowindow){
        infowindow.close();
      }
      infowindow = new google.maps.InfoWindow({content: mycontent});
      infowindow.open(mapItem2, marker);
    });
   }else{
    $('.hide-item').slideUp('normal');
  }
});

}
}
$(window).ready(function(){
  $.when(loadGoogleMaps( 3, "AIzaSyC9HKe9y3LxXaUQyRCtReg218_irnbfCQo", "pt-br") )
  .then(function() {
    initMap2();
  });
});



$(document).ready(function(){
//Slide fotos e videos
$('.slide-fotos .itens-slide').slick({
  adaptiveHeight: true,
  arrows: true,
  dots: false,
  infinite: true,
  slidesToShow: 4,
  swipeToSlide : true,
  autoplay: true,
  autoplaySpeed: 5000,
  touchThreshold: 70,
  prevArrow: '<div class="snick-btn left"><button type="button" class="slick-prev"><span><i class="icon-arrow-left"></i></span></button></div>',
  nextArrow: '<div class="snick-btn right"><button type="button" class="slick-next"><span><i class="icon-arrow-right"></i></span></button></div>',
    //lazyLoad: 'ondemand',
    responsive: [
    {
      breakpoint: 980,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 380,
      settings: {
        slidesToShow: 2
      }
    }
    ]
  });

$('.slide-fotos .itens-slide .image').magnificPopup({
  type: 'image',
  gallery: {
    enabled: true
  },
  mainClass: 'mfp-with-zoom image-block', // this class is for CSS animation below
  removalDelay: 300,
});
$('.slide-fotos .itens-slide .video').magnificPopup({
  type: 'iframe',
  mainClass: 'mfp-with-zoom video-block', // this class is for CSS animation below
  removalDelay: 300,
});
});
}
/*******************************************************************************
*  Google 360 Propaganda home
********************************************************************************/
if(document.getElementById('home')){
  $(document).ready(function(){
    var panorama;
    function initialize() {
      var fenway = new google.maps.LatLng(13.51481,144.8068167);
      var panoramaOptions = {
        position: fenway,
        pov: {
          heading: 1,
          pitch: 10
        },
        zoomControl:false,
        scrollwheel: false,
        disableDoubleClickZoom: true,
        disableDefaultUI: true,
        fullscreenControl: false,
        linksControl: false,
        panControl: false,
        clickToGo: false,
      };
      panorama = new  google.maps.StreetViewPanorama(document.getElementById('map-canvas'),panoramaOptions);
      if ($(window).width() > 960) {
        var move = true;
        var i = 0;
        window.setInterval(function () {
          panorama.setPov({
            heading: i,
            pitch: 9,
            zoom: 1
          });
          if (move) {
            i += 0.017;
          }
        }, 10);
      }
    }
        //google.maps.event.addDomListener(window, 'load', initialize);
        $.getScript("https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyC9HKe9y3LxXaUQyRCtReg218_irnbfCQo", function(){
          initialize();
        });
      });
}
/*******************************************************************************
*  Bloco Destaque topo home
********************************************************************************/
if(document.getElementById('destaques-bloco')){
  $(document).ready(function(){
    $('#destaques-bloco .destaque-inside .items').on('lazyLoaded', function (e, slick, img, src) {
      // $(img).parent().addClass('imgLiquidFill');
      // $(img).parent().imgLiquid({
      //   fill: true,
      //   horizontalAlign: "center",
      //   verticalAlign: "center"
      // });
    });
    $('#destaques-bloco .destaque-inside .items').slick({
      //adaptiveHeight: true,
      arrows: true,
      dots: false,
      infinite: true,
      slidesToShow: 1,
      swipeToSlide : true,
      autoplay: true,
      autoplaySpeed: 5000,
      touchThreshold: 70,
      prevArrow: '<div class="snick-btn left"><button type="button" class="slick-prev"><span><i class="icon-arrow-left"></i></span></button></div>',
      nextArrow: '<div class="snick-btn right"><button type="button" class="slick-next"><span><i class="icon-arrow-right"></i></span></button></div>',
      //lazyLoad: 'ondemand',
      responsive: [
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1
        }
      }
      ]
    });
  });
}


/*******************************************************************************
*  Interna Resultado Buscas
********************************************************************************/

if(document.getElementById('interna-resultado-busca')){
  function check_action_button() {
    var width_item = $(window).width();
    width = parseInt(width_item);
    if(width <= 767){

    }
    else{
      $('.categorias #demo3 .slicknav_btn').removeClass('slicknav_collapsed');
      $('.categorias #demo3 .slicknav_btn').addClass('slicknav_open');

      $('.categorias #demo3 .slicknav_nav').removeClass('slicknav_hidden');
      $('.categorias #demo3 .slicknav_nav').css('display', '');
    }
  }
  $(document).ready(function(){
    $('#categorias').slicknav({
      label: 'Categorias',
      duration: 600,
      duplicate: false,
      prependTo:'#demo3',
      allowParentLinks: true,
      closedSymbol: '<i class="icon-plus" aria-hidden="true"></i>',
      openedSymbol: '<i class="icon-minus" aria-hidden="true"></i>',
      init: function(){
        check_action_button();
        // $('.categorias .slicknav_menu ul li.slicknav_collapsed ul').each(function(){
        //   if($(this).get( 0 )){
        //     $(this).parent().find('.slicknav_arrow').html("<i class='fa fa-minus' aria-hidden='true'></i>");
        //     $(this).slideDown().removeClass('slicknav_hidden');
        //     $(this).parent().removeClass('slicknav_collapsed').addClass('slicknav_open');
        //   }
        // })
      },
    });
  });
  $(document).ready(function() {
    check_action_button();
    $(window).bind('resize', check_action_button);
  });
}

/*******************************************************************************
*  Página Detalhes
********************************************************************************/

if(document.getElementById('paginaDetalhes')){

}

/*******************************************************************************
*  Fotos
********************************************************************************/

if(document.getElementById('fotos')){
  $(document).ready(function() {
   $('.gallery').each(function() {
    $(this).magnificPopup({
      delegate: 'a',
      type: 'image',
      gallery: {
        enabled:true
      }
    });
  });
 });
}

/*******************************************************************************
*  Videos
********************************************************************************/

if(document.getElementById('videos')){
  $(document).ready(function() {
   $('.gallery').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });
 });
}

/*******************************************************************************
*  Interna Cadastro Empresa
********************************************************************************/

if(document.getElementById('interna-cadastro')){
  $('.selectize-multiple').selectize({
    //maxItems: 3
  });
  $('.selectize-simple').selectize({
    //maxItems: 3
  });

  $('#videos').selectize({
    delimiter: ',',
    persist: false,
    createOnBlur: true,
    create: function(input) {
      return {
        value: input,
        text: input
      }
    }
  });
  $('.selectize-cartoes').selectize({
    preload: true,
    highlight: false,
    render: {
      item: function(item, escape) {
        html = '<div class="item-select">' +
        '<span class="image">' +
        '<img src="' + item.img + '">' +
        '</span>' +
        '<div class="atributos">' +
        '<div class="titulo">' + item.nome+ '</div>'  +
        '</div>';
        html = html + '</div>';
        return html;
      },
      option: function(item, escape) {
        html = '<div class="item-select">' +
        '<span class="image">' +
        '<img src="' + item.img + '">' +
        '</span>' +
        '<div class="atributos">' +
        '<div class="titulo">' + item.nome + '</div>'  +
        '</div>';
        html = html + '</div>';
        return html;
      }
    },
  });
}

$(function(){
  if(document.getElementById('interna-cadastro')){

    $('#frmCadastro #telefone, #frmCadastro #telefone2, #frmCadastro #telefone3, #frmCadastro #telefone4').mask('(99) 9999-9999?9');
    $('#frmCadastro #cep').mask('99999-999');

    //Aplicando mascaras
    jQuery(function($) {
      $.mask.definitions['~']='[+-]';
      //Inicio Mascara Telefone
      $('#frmCadastro #telefone, #frmCadastro #telefone2, #frmCadastro #telefone3').focusout(function(){
        var phone, element;
        element = $(this);
        element.unmask();
        phone = element.val().replace(/\D/g, '');
        if(phone.length > 10) {
          element.mask("(99) 99999-999?9");
        } else {
          element.mask("(99) 9999-9999?9");
        }
      }).trigger('focusout');
    });

    //Termos
    $("#termos").click(function(){
      if($(this).is(':checked')){
        $('#aceito').val('1');
      }else{
        $('#aceito').val('');
      }
    });
  }
  if(document.getElementById('interna-contato')){

    $('#frmContato #telefone').mask('(99) 9999-9999?9');

    //Aplicando mascaras
    jQuery(function($) {
      $.mask.definitions['~']='[+-]';
      //Inicio Mascara Telefone
      $('#frmContato #telefone, #frmCadastro #telefone2, #frmCadastro #telefone3').focusout(function(){
        var phone, element;
        element = $(this);
        element.unmask();
        phone = element.val().replace(/\D/g, '');
        if(phone.length > 10) {
          element.mask("(99) 99999-999?9");
        } else {
          element.mask("(99) 9999-9999?9");
        }
      }).trigger('focusout');
    });
  }
});


/*****************************************************
** Funções que são chamadas
******************************************************/

//Busca da Subcategorias
function BuscaSubs()
{
  $.ajax({
    type: "POST",
    url: "ajax/busca_subs.php",
    data: "cat=" + $("#categoria").val(),
    beforeSend: function()
    {
      $("#Subs").html('<i class="fa fa-spinner fa-pulse fa-2x"></i>');
    },
    success: function(resposta)
    {
      $("#Subs").html(resposta);
      $('.selectize-multiple#subcategorias').selectize({});
    },
  });
}

function BuscaCidades()
{
  $.ajax({
    type: "POST",
    url: "ajax/busca_cidades.php",
    data: "uf=" + $("#estado").val(),
    beforeSend: function()
    {
      $("#Cidades").html('<i class="fa fa-spinner fa-pulse"></i>');
    },
    success: function(resposta)
    {
      $("#Cidades").html(resposta);
      $('.selectize-simple#cidade').selectize({});
    },
  });
}

function setCategory(id){
  $("#subcategoria").val('');
  $("#categoria").val(id);
  $('#frmBuscaHidden').submit();
}
function setSubcategory(id){
  $("#categoria").val('');
  $("#subcategoria").val(id);
  $('#frmBuscaHidden').submit();
}
function setAMPM(){
  if($("#ampmChk").is(':checked')){
    $("#ampm").val(1);
  }else{
    $("#ampm").val('');
  }
  $('#frmBuscaHidden').submit();
}

function setCid(){
  $("#cidade").val($('#cidadeFiltro').val());
  $('#frmBuscaHidden').submit();
}

function searchTerm(termo){
  $('#frmBuscaHidden input').val("");
  $('#termo').val(termo);
  $('#frmBuscaHidden').submit();
}





